import React, { Component, Fragment } from "react";

import Content from "../../components/Content/ContentPage/Content";
import ContentHeader from "../../components/Content/ContentHeader/ContentHeader";
import Card from "../../components/Card/Card";
import MessageHandler from "../../components/MessageHandler/MessageHandler";
import { required, length } from "../../util/validators";
import Loader from "../../components/Loader/Loader";
import Newloader from "../../components/Loader/NewLoader/NewLoader";
import ErrorHandler from "../../components/ErrorHandler/ErrorHandler";
import ColorForm from "../../components/Variant/ColorForm/ColorForm";
import Paginator from '../../components/Paginator/Paginator';

import "./Color.css";

const POST_FORM = {
  title: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required, length({ min: 2 })],
  },
  hexCode: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required, length({ min: 6 })],
  },
};

class Color extends Component {
  constructor(props) {
    super(props);

    this.state = {
      colors: [],
      active: false,
      showMessage: false,
      code: 0,
      label: "",
      title: "",
      isEditing: false,
      editingData: {},
      totalColors: 0,
      perPage: 20,
      colorPage: 1,
      colorsLoading: true,
    };
  }

   componentDidMount() {
    this.loadColors(1);
  }

  
  toggleClass() {
    this.setState({
      active: this.state.active ? false : true,
      isEditing: false,
      editingData: {}
    });
  }

  onDeleteColorHandler = (data) => {
    const Index = this.state.colors.findIndex((p) => p.id === data.code);

    this.setState({
      code: data.code,
      showMessage: true,
      label: data.label,
      title: this.state.colors[Index].title,
    });
  };

  onEditColorHandler = (data) => {
    const Index = this.state.colors.findIndex((p) => p.id === data.code);  
    
    this.setState({
      active: true,
      isEditing: true,
      editingData: this.state.colors[Index]
    });

    // this.props.onEditHandler.bind(this, {
    //   code: this.state.code,
    //   label: this.state.label,
    // });
  };

  onCancelColorHandler = () => {
    this.setState({
      code: 0,
      showMessage: false,
      label: "",
      title: "",
      isEditing: false,
      editingData: {},
    });
  };
  onDeleteColorTypeDicisionHandler = () => {
    this.props.onDeleteDataHandler({
      code: this.state.code,
      label: this.state.label,
    });
    this.setState({
      code: 0,
      showMessage: false,
      label: "",
      title: "",
      isEditing: false,
      editingData: {},
    });    
  };


  onEditHandler = () => {
    this.setState({
      isEditing: true,
    });
  };
  onDeleteHandler = (data) => {
      const graphqlQuery = {
        query: `
        mutation {
          deleteColor(code: ${parseInt(data.code)})
        }
      `,
      };
      fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
        method: "POST",
        headers: {
          Authorization: "Bearer " + this.props.token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(graphqlQuery),
      })
        .then((res) => {
          return res.json();
        })
        .then((resData) => {
            console.log(resData);
          if (resData.errors) {
            throw new Error("خطا در حذف رنگ!");
          }
          // this.newResetHandler();
          this.setState((prevState) => {
            let updatedPosts = [...prevState.colors];
            const postIndex = prevState.colors.findIndex(
              (p) => p.id === data.code
            );
            if (postIndex > -1) {
              updatedPosts.splice(postIndex, 1);
            }

            return {
              colors: updatedPosts,
            };
          });
        })
        .catch((err) => {
          console.log(err);
        //   this.setState({ categoriesLoading: false });
        });        
  };

  loadColors = (colorPage) => {
    if (colorPage) {
      this.setState({ colorsLoading: true, colors: [] });
    }

    const graphqlQuery = {
        query: `
          query FetchColors($page: Int, $perPage: Int) {
            allColors(page: $page, perPage: $perPage) {
              Colors {
                id
                title
                hexCode
                isActive
              }
              totalColors
            }
          }
        `,
      variables: {
        page: colorPage,
        perPage: this.state.perPage
      }
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دریافت اطلاعات!");
        }

        this.setState({
            colors: resData.data.allColors.Colors,
            totalColors: resData.data.allColors.totalColors,
            colorsLoading: false,
            colorPage: colorPage 
        });
           
      })
      .catch(this.catchError);
  };

  acceptColorChangeHandler = (postData) => {
    this.setState({
      editLoading: true,
    });
    
    let graphqlQuery;
    if (postData.editingCode !== 0) {
        graphqlQuery = {
            query: `
            mutation updatedColor($code: Int!, $title: String!, $hexCode: String!, $isActive: Boolean!) {
                updateColor(code: $code, colorInput: {title: $title, hexCode: $hexCode, isActive: $isActive}) {
                id
                title
                hexCode
                }
            }
            `,
            variables: {
            code: parseInt(postData.editingCode),
            title: postData.title,
            hexCode: postData.hexCode,
            isActive: true,
            },
        };
    } else {
        graphqlQuery = {
            query: `
            mutation createNewColor( $title: String!, $hexCode: String!, $isActive: Boolean!) {
                createColor(colorInput: {title: $title, hexCode: $hexCode, isActive: $isActive}) {
                id
                title
                hexCode
                }
            }
            `,
            variables: {
            title: postData.title,
            hexCode: postData.hexCode,
            isActive: true,
            },
        };     
    }     

    return fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
        method: "POST",
        body: JSON.stringify(graphqlQuery),
        headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
        },
    })
   
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
          
        if (resData.errors && resData.errors[0].status === 422) {
          throw new Error(
            "Validation failed. Make sure the email address isn't used yet!"
          );
        }
        if (resData.errors) {
          throw new Error("ورود کاربر ناموفق!");
        }

        let resDataField = "createColor";
        if (postData.editingCode !== 0) {
          resDataField = "updateColor";          
        }

        var post = {
          id: resData.data[resDataField].id,
          title: resData.data[resDataField].title,
          hexCode: resData.data[resDataField].hexCode,
          isActive: resData.data[resDataField].isActive,
        };

        this.setState((prevState) => {
            let updatedTotalColors = prevState.totalColors;
            let updatedPosts = [...prevState.colors];
            if (postData.editingCode !== 0) {
              const postIndex = prevState.colors.findIndex(
                (p) => p.id == post.id
                );
              updatedPosts[postIndex] = post;
            } else {
              updatedTotalColors++;
              if (prevState.colors.length >= prevState.perPage) {
                updatedPosts.pop();
              }
              updatedPosts.unshift(post);
            }

            

      // perPage: 10,
      // colorPage: 1,

            return {
              active: false,
              colors: updatedPosts,
              totalColors: updatedTotalColors
            };
          
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isEditing: false,
          editColor: false,
          editLoading: false,
          error: err,
        });
      });
  };

  

  errorHandler = () => {
    this.setState({ error: null });
  };

  catchError = (error) => {
    this.setState({ error: error });
  };

  render() {
    return (
      <Fragment>
        <ErrorHandler error={this.state.error} onHandle={this.errorHandler} />
        <MessageHandler
          showMessage={this.state.showMessage}
          onHandle={this.onCancelColorHandler}
          message={
            "آیا می‌خواهید " +
            this.state.title +
            '" را حذف کنید؟'
          }
          onCancelModal={this.onCancelColorHandler}
          onAcceptModal={this.onDeleteColorTypeDicisionHandler}
          acceptMessage="تایید"
          cancelMessage="لغو"
        />
        <Content>
            <ContentHeader
              headerAction="درج رنگ"
              headerDescription="مدیریت رنگها را در این صفحه انجام دهید"
            />
            <Card> 
                <span className="mn-promo-report__header-card-bold-title">جستجو و فیلتر</span>
                <div className="mn-card__body">
                    <form className="mn-ui-form" method="POST" id="searchForm" onSubmit={e => { e.preventDefault(); }}>
                        <div className="mn-ui-form__row mn-ui-form__row_padding">
                            <div className="mn-grid__row mn-grid__row--gap-lg mn-brand-card__footer">
                                <div className="c-ui-paginators">
                                    <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--sm-12 mn-grid__col--xs-gap" style={{minWidth: '400px'}}>
                                        <label className="uk-form-label uk-flex uk-flex-between">جستجو:</label>
                                        <div className="field-wrapper ui-select ui-select__container">
                                            <div className="mn-ui-input">
                                                <input type="text" name="brand-search" className="mn-ui-input__field mn-ui-input__field--order" id="brand-search" placeholder="عبارت مورد نظرتان را وارد کنید..."/>
                                            </div>                                        
                                        </div>
                                    </div>
                                    <div className="mn-grid__col--gap-lg mn-grid__col--xs-gap uk-flex uk-flex-bottom">
                                        <button className="mn-search-btn mn-search-btn--xs-block mn-search-btn--active mn-search-btn--search-form mn-search_padding" id="submitButton">
                                            <span className="mn-seach__btn">جستجو</span>
                                        </button>
                                        <button type="button" className="mn-content-categories__search-reset" id="resetButton"></button>
                                    </div>
                                </div>
                                <div className="mn-grid__col--gap-lg mn-grid__col--xs-gap uk-flex uk-flex-bottom">
                                    <button onClick={this.toggleClass.bind(this)} type="button" className="mn-search-btn mn-search-btn--xs-block mn-search-btn--active--green mn-mega-campaigns__btns-green-plus mn-search_padding" id="submitButton">
                                        <span className="mn-seach__btn">ایجاد رنگ جدید</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>

                    <div
                      className={[
                        "mn-grid__row mn-brand__gap",
                        `${!this.state.active ? "uk-hidden" : ""}`,
                      ].join(" ")}
                    >
                      <ColorForm
                        toggleClass={this.toggleClass.bind(this)}
                        onAcceptModal={this.acceptColorChangeHandler.bind( this )}
                        isEditing={this.state.isEditing}
                        editingData={this.state.editingData}
                        userId={this.props.userId}
                        token={this.props.token}
                      />
                    </div>             

                </div>
            </Card>
            <Card>
                <div className="c-card__wrapper">
                    <div className="mn-card__header mn-card__header--table">
                        <Paginator
                          onNext={this.loadColors.bind(this)}
                          lastPage={Math.ceil(this.state.totalColors / this.state.perPage)}
                          totalColors={this.state.totalColors}
                          currentPage={this.state.colorPage}
                        />
                    </div>
                    <div className={[ "c-card__body c-ui-table__wrapper", this.state.colorsLoading ? "c-content-loading" : "" ].join(" ")}>
                        <table className="c-ui-table   js-search-table " data-sort-column="" data-sort-order="asc" data-search-url="/commissions/search/" data-auto-reload-seconds="0" data-new-ui="1" data-is-header-floating="1" data-has-checkboxes="">
                            <thead>
                                <tr className="c-ui-table__row">
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="js-search-table-column">ردیف</span>
                                    </th>
                                    
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">رنگ</span>
                                    </th>
                                
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">نام رنگ</span>
                                    </th>
                                    
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">کد رنگ</span>
                                    </th>
                                    
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">ویرایش رنگ</span>
                                    </th>
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">حذف رنگ</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.colors !== [] && (
                                <Fragment>
                                    {this.state.colors.map((data, index) => (
                                    <tr>
                                        <td className="c-ui-table__cell c-ui-table__cell--smaller">
                                            {index + 1}
                                        </td>
                                        <td className="c-ui-table__cell">
                                            <div className="mn-content-color-container mn-content-color-container-noborder" style={{backgroundColor: "#"+data.hexCode}}>
                                                                            
                                            </div>
                                        </td>
                                        <td className="c-ui-table__cell">{data.title}</td>
                                        <td className="c-ui-table__cell">{data.hexCode}</td>                                        
                                        <td className="c-ui-table__cell ">
                                            <span
                                                className="mn-link-row__status-ui edit"
                                                onClick={this.onEditColorHandler.bind(this, {
                                                code: data.id,
                                                })}
                                            >
                                                {"ویرایش"}
                                                <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                                            </span>
                                        </td>
                                        <td className="c-ui-table__cell">
                                            <span
                                                className="mn-link-row__status-ui delete"
                                                onClick={this.onDeleteHandler.bind(this, {
                                                code: data.id,
                                                })}
                                            >
                                                {"حذف"}
                                                <i className="fa fa-trash-o" aria-hidden="true"></i>
                                            </span>
                                        </td>
                                    </tr>
                                    ))}
                                </Fragment>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="c-card__footer">
                        <Paginator
                          onNext={this.loadColors.bind(this)}
                          lastPage={Math.ceil(this.state.totalColors / this.state.perPage)}
                          totalColors={this.state.totalColors}
                          currentPage={this.state.colorPage}
                        />
                    </div>
                    {this.state.colorsLoading && (
                      <div className="c-content-loader">
                        <Newloader/>
                      </div>
                    )} 
                </div>
            </Card>
        </Content>
      </Fragment>
    );
  }
}

export default Color;

